import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { catchError, Observable, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { Utils } from "src/app/utils/utils";

@Injectable({providedIn: "root"})
export class BranchHierarchyLogsService {
    private readonly apiUrl: string;

    constructor(private readonly httpClient: HttpClient) 
    {
        this.apiUrl = `${environment.endpoint}api/branchhierarchy`;
    }

    getBranchHierarchyAudit(id: number): Observable<any[]> {
        return this.httpClient.get<any[]>(`${this.apiUrl}/audit/${id}`).pipe(
            catchError(error => {
                Utils.writeLog(this.httpClient, `${this.apiUrl}/audit/${id}`, error);
                return throwError(() => error);
            })
        );
    }
}
